export enum OutageWindowFrequency {
    Daily = "Daily",
    SundayOfEachWeek = "SundayOfEachWeek",
    MondayOfEachWeek = "MondayOfEachWeek",
    TuesdayOfEachWeek = "TuesdayOfEachWeek",
    WednesdayOfEachWeek = "WednesdayOfEachWeek",
    ThursdayOfEachWeek = "ThursdayOfEachWeek",
    FridayOfEachWeek = "FridayOfEachWeek",
    FirstMondayOfEachMonth = "FirstMondayOfEachMonth",
    SecondMondayOfEachMonth = "SecondMondayOfEachMonth",
    ThirdMondayOfEachMonth = "ThirdMondayOfEachMonth"
}

export const outageWindowFrequencyDescriptions: Record<OutageWindowFrequency, string> = {
    [OutageWindowFrequency.Daily]: "Daily",
    [OutageWindowFrequency.SundayOfEachWeek]: "Sunday of each week",
    [OutageWindowFrequency.MondayOfEachWeek]: "Monday of each week",
    [OutageWindowFrequency.TuesdayOfEachWeek]: "Tuesday of each week",
    [OutageWindowFrequency.WednesdayOfEachWeek]: "Wednesday of each week",
    [OutageWindowFrequency.ThursdayOfEachWeek]: "Thursday of each week",
    [OutageWindowFrequency.FridayOfEachWeek]: "Friday of each week",
    [OutageWindowFrequency.FirstMondayOfEachMonth]: "First Monday of each month",
    [OutageWindowFrequency.SecondMondayOfEachMonth]: "Second Monday of each month",
    [OutageWindowFrequency.ThirdMondayOfEachMonth]: "Third Monday of each month",
}